var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEraserPicto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11.1992H4.58034M8.26576 7.83682L4.29359 3.74967M1.31326 6.58047L6.23126 1.52147C6.43191 1.31513 6.704 1.19922 6.98771 1.19922C7.27142 1.19922 7.54352 1.31513 7.74416 1.52147L10.3923 4.2455C10.5929 4.4519 10.7055 4.73179 10.7055 5.02364C10.7055 5.31548 10.5929 5.59538 10.3923 5.80178L5.44753 10.8883C5.25393 11.0872 4.99147 11.199 4.71783 11.199C4.44418 11.199 4.18172 11.0872 3.98812 10.8883L1.31326 8.13674C1.11268 7.93035 1 7.65045 1 7.3586C1 7.06676 1.11268 6.78686 1.31326 6.58047Z",
    stroke: "#666666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserPicto);
export default __webpack_public_path__ + "static/media/eraser_picto.bd39756c594b336a783a8d3fbdc1cefd.svg";
export { ForwardRef as ReactComponent };